/* 当前生效的 AI 模型标签（用途 → 模型名），供界面文案动态展示，避免把模型名写死在组件里。
   数据来自 GET /ai/models（任意登录用户可读）；结果在模块级缓存，同一次会话只请求一次。 */
import { useEffect, useState } from "react";
import api from "./api";

let _cache = null;
let _inflight = null;

function fetchModels() {
  if (_cache) return Promise.resolve(_cache);
  if (!_inflight) {
    _inflight = api
      .get("/ai/models")
      .then(({ data }) => (data && data.models) || {})
      .catch(() => ({}))
      .then((m) => {
        _cache = m;
        _inflight = null;
        return m;
      });
  }
  return _inflight;
}

/** 返回 { default, extract, image, search, stt, tts }，未加载完成时为空对象。 */
export function useAiModels() {
  const [models, setModels] = useState(_cache || {});
  useEffect(() => {
    let alive = true;
    fetchModels().then((m) => { if (alive) setModels(m); });
    return () => { alive = false; };
  }, []);
  return models;
}
